import { httpBatchLink, httpLink } from "@trpc/client"
import { createTRPCReact } from "@trpc/react-query"

import trpcTransformer from "@forento/shared/utilities/trpcTransformer"

import type { AppRoutes } from "../../../api/src/routes"

export const query = createTRPCReact<AppRoutes>()

const trpc = query.createClient({
	links: [
		CONFIG.isDevelopment
			? httpLink({ url: CONFIG.apiUrl, transformer: trpcTransformer })
			: httpBatchLink({ url: CONFIG.apiUrl, transformer: trpcTransformer }),
	],
})

export default trpc
